module.exports = __webpack_public_path__ + "media/img/payments/card-icon-dc8bcda319d42359fce4b3bac724db90.svg";